module.exports = __webpack_public_path__ + "static/media/PM-10.5e0b3744.png";